module.exports = __webpack_public_path__ + "b27d0c28be5000437ffd8145dcf8cb95.svg";